import { render } from "./CrowdfundingGuideView.vue?vue&type=template&id=151a8ea8"
import script from "./CrowdfundingGuideView.vue?vue&type=script&lang=js"
export * from "./CrowdfundingGuideView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__